export default class ProvinceModel {
    idNProvincia: number | null;
    idTProvincia: number | null;
    fkNPais: number | null;
    fldTProvinciaEndonimo: string | null;
    fldTProvinciaExonimo: string | null;

    constructor() {
        this.idNProvincia = null;
        this.idTProvincia = null;
        this.fkNPais = null;
        this.fldTProvinciaEndonimo = null;
        this.fldTProvinciaExonimo = null;
    }
}